import { useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';

import type { TCurriculumList } from '../../graphql/types';


const getCurriculumList = async (courseId: string): Promise<TCurriculumList> => {
  try {
    const endpoint = `https://cms.academy.klaviyo.com/api/course/${courseId}/curriculum-list`;
    const response = await fetch(endpoint, { credentials: 'include' });
    const data = await response.json();

    return data?.lessons || {};
  } catch (e) {
    Sentry.captureException(e);
    return {};
  }
};

export const useGetCurriculumList = (courseId: string) => {
  const [curriculumList, setCurriculumList] = useState<TCurriculumList>({});

  useEffect(() => {
    if (!courseId) {
      return;
    }

    const getCurriculum = async () => {
      const data = await getCurriculumList(courseId);

      if (data) {
        setCurriculumList(data);
      }
    };

    getCurriculum();
  }, [courseId]);

  return curriculumList;
};
